/* eslint-disable no-param-reassign */
export default function concatGroupedHeaders(
    headers,
    groupHeaders,
    leftColumnField = 'team_name'
) {
    const leftColumnIndex = headers.findIndex(
        (d) => d.field === leftColumnField
    )
    const sliceIndex = leftColumnIndex !== -1 ? leftColumnIndex + 1 : 0

    return [
        ...headers.slice(0, sliceIndex),
        ...groupHeaders,
        ...headers.slice(sliceIndex),
    ]
}
